import React from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Aboutus from "./pages/Aboutus";
import Home from "./pages/Home";
import Portfolio from "./pages/Portfolio";
import Investment from "./pages/Invetsment";
import LoginPage from "./pages/Loginpage";
import ScrollToTopButton from "./components/ScrollToTopButton";
import ScrollToTop from "./components/ScrollToTop"; // ✅ import here

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop /> {/* ✅ trigger scroll to top on route change */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/investment" element={<Investment />} />
          <Route path="/login" element={<LoginPage />} />
        </Routes>
      </BrowserRouter>
      <ScrollToTopButton />
    </>
  );
}

export default App;
